import { render } from "./SimilarSites.vue?vue&type=template&id=66d68f30&scoped=true"
import script from "./SimilarSites.vue?vue&type=script&lang=js"
export * from "./SimilarSites.vue?vue&type=script&lang=js"

import "./SimilarSites.vue?vue&type=style&index=0&id=66d68f30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d68f30"]])

export default __exports__